import React from 'react';
import { formatDateTime } from '../utils';

function statusBadgeClass(status) {
  if (status === 'success') return 'badge-green';
  if (status === 'running') return 'badge-blue';
  if (status === 'failed') return 'badge-red';
  return 'badge-yellow';
}

// Shared run-history table for the integration syncs. They all record the same
// shape — started_at, status, a handful of record counts, who triggered it —
// and differ only in which counts are meaningful, so callers pass `metrics`
// (see SYNC_METRICS) to pick the columns.
export default function SyncHistoryTable({ title = 'Sync History', rows, metrics, emptyMessage = 'No sync history yet' }) {
  return (
    <div className="card">
      <div className="card-header"><h3>{title}</h3></div>
      {rows.length === 0 ? (
        <div className="empty-state">{emptyMessage}</div>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Started</th>
              <th>Status</th>
              {metrics.map(m => <th key={m.key}>{m.label}</th>)}
              <th>By</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id}>
                <td style={{ fontSize: 13, color: 'var(--text-2)' }}>{formatDateTime(r.started_at)}</td>
                <td><span className={`badge ${statusBadgeClass(r.status)}`}>{r.status}</span></td>
                {metrics.map(m => {
                  const value = r[m.key];
                  // Draw attention to a nonzero count only where it signals a
                  // problem — an error tally, not a routine processed count.
                  const highlight = m.badgeWhenNonZero && Number(value) > 0;
                  return (
                    <td key={m.key} style={{ fontSize: 14 }}>
                      {highlight
                        ? <span className={`badge ${m.badgeWhenNonZero}`}>{value}</span>
                        : (value ?? 0)
                      }
                    </td>
                  );
                })}
                <td style={{ fontSize: 13, color: 'var(--text-2)' }}>
                  {r.triggered_by_name || r.triggered_by?.slice(0, 8) || 'System'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
